import { TFunction } from "i18next";

export const FormHeader = (t: TFunction<any>) => (props: any) => {
    const { schema, errors, status, submitCount = 0, touched } = props;
    const { success = false, message, id } = status ?? {};
    return <>{success &&
        <div className="alert alert-primary">
            <div>{message}</div>
            <div>{id}</div>
        </div>}
        <div>
            {submitCount > 0 && Object.keys(errors ?? {}).filter(x => touched[x] !== undefined).map(x => <div className="alert alert-primary">
                <span>{t("Errors.Summary.Message", "There was a issue with the field ")}</span><a href={`${location.pathname}#${x}`}>{schema.fields.filter((y: any) => y.key === x)[0]?.nameLabel?.toLowerCase() ?? schema.fields.filter((y: any) => y.key === x)[0]?.label?.toLowerCase()}</a>.
            </div>)}
        </div>
    </>
}